import services from 'services/module';
import {HttpSvcFactory} from './HttpSvc';
import {Utils} from '../underscore-extensions';

export class HttpProjectSvc {
    product: AnimatronProduct = Utils.getProduct();

    constructor(private $rootScope: ng.IRootScopeService,
                private $q: ng.IQService,
                private $state: ng.ui.IStateService,
                private $http: ng.IHttpService,
                private HttpSvc: HttpSvcFactory) {
    }

    removeProject(id: string, stopDefaultConfirm = false, showSuccessMessage = true) {
        const productWord = this.product === 'WAVE' ? 'video' : 'project';
        if (!stopDefaultConfirm && !confirm(this.$rootScope.t(`${productWord}.remove.confirm`))) {
            return this.$q.reject();
        }

        return this.$http
            .delete(`${options.apiDomain}/project/${id}`, {headers: options.headers})
            .then(() => {
                showSuccessMessage && _.notification.showSuccess(this.$rootScope.t(`${productWord}.remove.success`));
                this.$rootScope.$emit('project:remove', id);
            });
    }

    getRenderedVideo(id: string) {
        return this.HttpSvc('project/resources/video', id)
            .get()
            .then((res: ApiError | any) => {
                return res.data.errorCode ? this.$q.reject(res.data.errorMessage) : res.data;
            });
    }
}

services.service('httpProjectSvc', HttpProjectSvc);



// WEBPACK FOOTER //
// ./app/assets/javascripts/services/HttpProjectSvc.ts